import { MasterdataAService } from "../../../services";


class MasterdataListController implements ng.IComponentController {

    private activePill: any;
    private types: any;

    constructor(private MasterdataAService: MasterdataAService,
    private $state : ng.ui.IStateService, private $stateParams: ng.ui.IStateParamsService, private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    public $onInit = () => {
        this.activePill = parseInt(this.$stateParams['tab']);
        this.types = this.MasterdataAService.getTypes();

        console.log(this.types);

        this.types.forEach(item => {
            this.MasterdataAService.getItems(item.id).then(( data )=> {
                item.data = data;
            })
        });
    }

    public setTab = (index) => {

        this.$timeout(() => {
            this.$state.go('.', { tab: this.activePill }, {notify: false})
        })
       
    } 

}

export const masterdataListComponent: ng.IComponentOptions = {
    controller: MasterdataListController,
    template: require('./masterdata.list.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/settings/masterdata/masterdata.list.component.ts